import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeSecretaryComponent } from './pages/home/home-secretary.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { OrganizationSecretariesComponent } from './pages/organization/organization.component';
import { PractionerSecretaryComponent } from './pages/practioner/practioner.component';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { ScheduleAppointmentSecretaryComponent } from './pages/schedule/appointment/schedule-appointment.component';
import { ScheduleSecretaryProcedureComponent } from './pages/schedule/procedure/schedule-procedure.component';
import { FirstAccessGuard } from 'app/core/guards/first-access.guard';
import { SecretaryDashboardComponent } from './pages/dashboard/dashboard.component';
import { ProcedureBySpecialistComponent } from './pages/schedule/procedure-by-specialist/procedure-by-specialist.component';
import { UserTypeGuard } from 'app/core/guards/user-type.guard';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { SecretaryBankAccountComponent } from './components/secretary-bank-account/secretary-bank-account.component';

const routes: Routes = [
  {
    path: '',
    component: ScheduleComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'agendar',
    component: ScheduleComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'instituicoes',
    component: OrganizationSecretariesComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'especialistas',
    component: PractionerSecretaryComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'agenda/status',
    component: ScheduleStatusComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'agendar/consulta',
    component: ScheduleAppointmentSecretaryComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'agendar/exame',
    component: ScheduleSecretaryProcedureComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'agendar/clinicas',
    component: ScheduleSecretaryProcedureComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'agendar/especialistas/exame',
    component: ProcedureBySpecialistComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'faturamento',
    component: SecretaryDashboardComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'account',
    component: SecretaryBankAccountComponent,
    data: {
      "onlyUserType" : "secretary"
    }
  },
  {
    path: 'dashboard',
    component: SecretaryDashboardComponent,
    canActivate: [FirstAccessGuard,  AuthGuard, UserTypeGuard],
    data: {
      "onlyUserType" : "secretary"
    }
  },
  { 
    path: 'meus-dados', 
    component: ProfileComponent,  
    data: {
      "onlyUserType" : "secretary"
   },
   canActivate: [AuthGuard, UserTypeGuard],
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SecretariesRoutingModule {}
